// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__6vxrY","toastAnimation":"Toast_toastAnimation__wZEDg"};